module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImage4_1278846250.c0b48be0.png";